//***********  SpecificationBannerStep1.jsx **** */
import React from "react";
import "../Specification/SpecificationBannerStep1.scss"

const SpecificationBannerStep1 = (props) => {
  
  const {picturePath} = props

let myArray = []
const extractFeatures = (a) => {
  //window.bc = myArray
  if (a) {
    return a.map((x, index) => {
      return <h5 key={index}>{x}</h5>;
    })
  }
}

      return (
<div className="speciication__wrap--position">
      <div className="speciication-selected-banner_wrap--decor">
        <div className="speciication-model__title-name">
          <h1>{props.selectedModel.name}</h1>
        </div>
        <div className="speciication-model__title-frequency">
          <p>{props.selectedModel.frequencyRange}</p>
        </div>
        <div className="speciication-model__info-wrap">
          <div className="speciication-model__package">
            <span>Packaging: </span>{props.selectedModel.packaging}
          </div>

          <div className="speciication-model__features">
            <h4>Features:</h4>
            {extractFeatures(props.features)}
          </div>
        </div>
      </div>
    </div>
      )
  }


export default SpecificationBannerStep1